<template>
	<div class="col-xs-12">
		<div id="g-recaptcha">

		</div>
	</div>
</template>

<script>
	import GenericProfileInfo from "@/components/shared/GenericProfileInfo.vue";
	import {common} from "@/global/common.js";
	import {notifications} from "@/global/notifications.js";
	import {api} from "@/global/framework/api.js";

	export default {
		name: "Recaptcha",
		data() {
			return {
				recaptchaId: 0
			}
		},
		async mounted() {
			this.setUpRecaptcha();
		},
		methods: {
			setUpRecaptcha() {
				window.onRecaptchaloadCallback = this.onRecaptchaReady;
				let s = document.createElement("script");
				s.type = "text/javascript";
				s.async = true;
				s.defer = true;
				s.src = "https://www.google.com/recaptcha/api.js?onload=onRecaptchaloadCallback&render=explicit";
				document.head.append(s);
			},
			onRecaptchaReady(r) {
				//console.log("Recaptcha has been loaded:", r);
				this.recaptchaId = grecaptcha.render('g-recaptcha',
					{
						sitekey: '6Ld6WFkUAAAAAL-1swBy8_jmxjeawXPdU7DFyR-I',
						callback: function () {
						}
					});
			},
			async checkCaptcha() {
				let recaptchaToken = await grecaptcha.getResponse(this.recaptchaId);
				if (this.hasValue(recaptchaToken)) {
					let url = `Shared/ValidateCaptcha`;
					url = common.appendUrlParameter(url, 'captchaToken', recaptchaToken);
					let result = await $.ajax({type: "GET", url: url});
					if (result != null) {
						return true;
					} else {
						notifications.showError({message: "Recaptcha is required", title: "Error"});
						return false;
					}
				} else {
					notifications.showError({message: "Recaptcha is required", title: "Error"});
					return false;
				}
			},
		}
	}
</script>

<style scoped>

</style>